import { WsbLandingCSS } from './WsbLandingCSS.styled'
import { resources } from './resources'
import { CONTENT_TYPES } from 'constants/games/contentTypes'

import { useNavigate } from 'react-router-dom'

export const WsbLanding = () => {
  const navigateTo = useNavigate()
  const handleCardSelected = () => navigateTo(`/game/${CONTENT_TYPES.LVG_CRYPTO}`)
  return (
    <WsbLandingCSS>
      <div id='landing'>
        <div class='mp_games'>
          <div onClick={handleCardSelected} class='game_box infinite_winnings'>
            <div class='top'> </div>
            <div class='bottom'>
              <div class='left'>
                <div>
                  <img src={resources.leveraged_gaming_text} />
                </div>
                <p>
                  The beloved and insanely popular degen option trading forum r/Wallstreetbets now has a brand new
                  leveraged gaming experience, powered by YOLOREKT.
                  <strong>Up-to 1000x leverage on stocks, crypto, and custom ETFs.</strong>
                </p>
              </div>
              <div class='right'>
                <button>Bid now</button>
                <div class='powered_by_landing'>
                  <img src={resources.powered_by_yolorekt_landing} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class='landing_level join'>
          <form>
            <input type='text' placeholder='Join the YOLOREKT mailing list' />
            <button>Join</button>
          </form>
        </div>

        <footer>
          <div id='landing-details'>
            <div id='made-with'>
              Powered by&nbsp;
              <a href='https://yolorekt.finance' target='blank'>
                YOLOREKT Inc.
              </a>
            </div>

            <div id='priv-terms'>
              <a href='https://docs.yolorekt.finance/docs/legal/privacy-policy' target='blank'>
                Privacy Policy
              </a>
              &nbsp;&nbsp;•&nbsp;&nbsp;
              <a href='https://docs.yolorekt.finance/docs/legal/terms-of-service' target='blank'>
                Terms of Service
              </a>
            </div>

            <div id='copyright'>
              <strong>© Copyright 2023 </strong>
              All rights reserved
            </div>
          </div>
        </footer>
      </div>
    </WsbLandingCSS>
  )
}
